import { render } from "./word.vue?vue&type=template&id=27265216&scoped=true"
import script from "./word.vue?vue&type=script&lang=js"
export * from "./word.vue?vue&type=script&lang=js"

import "./word.vue?vue&type=style&index=0&id=27265216&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@https+++registry.npmmirror.com+vue-loader+-+vue-loader-17.4.2.tgz_vue@3.2.13_webpack@5.95.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27265216"]])

export default __exports__